var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-autocomplete',{ref:"labelInput",attrs:{"append-to-body":"","data":_vm.filteredLabels,"open-on-focus":"","loading":_vm.loading,"placeholder":_vm.$t('sale.label_placeholder')},on:{"input":_vm.updateLabel},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})
}
var staticRenderFns = []

export { render, staticRenderFns }